import {
  FiltersFieldNames,
  IFilterFieldConfig,
  IFilterValues,
} from "../../types";

import { getCheckboxFilterWithOptions } from "../GenericFields/CheckboxTypeFilters/getCheckboxFilterWithOptions";
import { getContractStatus } from "./getContractStatus";

export const contractStatusFilter: IFilterFieldConfig<IFilterValues> = {
  name: FiltersFieldNames.ContractStatus,
  defaultValue: {},
  modifiers: { showFilterControl: true },
  getFilterFiledProps: (props) =>
    getCheckboxFilterWithOptions({ ...props, getOptions: getContractStatus }),
};
